import {
	Component,
	OnInit,
	ViewChild,
	AfterViewInit,
	ViewEncapsulation,
} from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import brLocale from '@fullcalendar/core/locales/pt-br';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { AgendaService } from 'src/app/services/actions/agenda.service';
import { ToastrService } from 'ngx-toastr';
import { AtendimentoService } from 'src/app/services/actions/atendimento.service';
import { ServerRoutes } from 'src/app/ServerRoutes';
import * as moment from 'moment';
import _ from 'lodash'

@Component({
	selector: 'app-agenda',
	templateUrl: './agenda.component.html',
	styleUrls: ['./agenda.component.scss'],
})
export class AgendaComponent {
	@ViewChild("calendar", { static: true })
	calendarComponent: FullCalendarComponent;
	locales = [brLocale];
	calendarPlugins = [dayGridPlugin, interactionPlugin];
	// os itens adicionados neste array devem ser adicionados via concat (this.events = this.events.concat({...}))
	events = [];
	postagensDoDia = [];
	dataClicada = "Selecione um dia do calendário";
	status = "todos";

	// horarios disponiveis
	agendaCustomizada = [];
	agendaUTC = [];
	singleHours = [];
	horariosDoDia = [];
	hourCanUseToSingleHour = [];
	diaCancelado = {};
	infoDay = {};
	newHour

	atendimentos;
	diasComHorario = []
	diasComHorarioLoaded = false
	options = {
		eventTimeFormat: {
			hour: '2-digit',
			minute: '2-digit',
			meridiem: false
		}
	}

	offset = Math.round(moment().utcOffset() / 60);
	loadingHorarios = false

	constructor(
		private agendaService: AgendaService,
		private toastr: ToastrService,
		private atendimentoService: AtendimentoService,
		private routes: ServerRoutes
	) {}

	async ngAfterViewInit() {
		await this.mountAgenda()
		await this.getAtendimentos()
	}

	async mountAgenda () {
		for (let horario = 0; horario < 24; horario++) {
			this.agendaCustomizada.push([]);
			for (let i = 0; i < 7; i++) {
				this.agendaCustomizada[horario].push({
					hora: (horario < 10 ? "0" + horario : horario) + ":00",
					selected: false,
				});
			}
			this.horariosDoDia.push(horario + ":00");
		}
		await this.agendaService.getAgenda().subscribe(
			(res) => {
				// @ts-ignore
				this.agendaUTC = res['horariosDefinidos']

				if (!_.isEmpty(res['singleHours'])) {
					res['singleHours'].forEach((element, index) => {
						const includeUtc = moment(element.day).hour(parseInt(element.hour) + this.offset).minute(0).second(0)
						element.day = includeUtc.format('YYYY-MM-DD')
						element.hour = includeUtc.format('HH')
						element.dayNumber = includeUtc.day()
						this.singleHours[index] = element
					})
				}
				
				for (let hora = 0; hora < this.agendaUTC.length; hora++) {
					for (let dia = 0; dia < this.agendaUTC[hora].length; dia++) {
						if (this.agendaUTC[hora][dia].selected) {
							let horaCorreta = hora + this.offset
							let diaCorreto = dia;

							if (horaCorreta >= 24) {
								horaCorreta = horaCorreta - 24;
								diaCorreto++;
								if (diaCorreto > 6) {
									diaCorreto = 0;
								}
							} else if (horaCorreta < 0) {
								horaCorreta = horaCorreta + 24;
								diaCorreto--;
								if (diaCorreto < 0) {
									diaCorreto = 6;
								}
							}

							this.agendaUTC[hora][dia].selected = false
							this.agendaCustomizada[horaCorreta][diaCorreto].selected = true
							this.diasComHorario.push(diaCorreto)
						}
					}
				}
				this.diasComHorario = _.uniq(this.diasComHorario)
				this.diasComHorarioLoaded = true
			},
			(err) => {
				console.log(err);
			}
		)
	}

	handleDateClick(arg) {
		const clickDate = arg.date ? arg.date : arg.event.start
		this.createInfoDay(clickDate)

		// @ts-ignore
		$("#modalDia").modal();
	}

	createInfoDay(clickDate) {
		const clickedDateFormatted = moment(clickDate).format("YYYY-MM-DD")
		const atendimentosDia = _.filter(this.atendimentos, function(o) {
			return moment(o.date).format("YYYY-MM-DD") === clickedDateFormatted
		})

		const freeDay = _.isEmpty(atendimentosDia)

		this.infoDay = {
			formatado: moment(clickDate).format("DD/MM/yyyy"),
			date: clickedDateFormatted,
			isPast: moment(clickDate).isAfter(moment().format("YYYY-MM-DD")),
			freeDay
		}

		const dayNumber = moment(clickDate).day()
		const horasJaMarcada = []
		const agenda = this.agendaCustomizada
		let horariosDia = [];
		let cont = 0

		for (let hora = 0; hora < agenda.length; hora++) {
			if (agenda[hora][dayNumber].selected) {
				let horaCorreta = moment().hour(hora).format('HH')
				horariosDia[cont] = { atendimento: '' }

				const atendimentoHoraIndex = _.findIndex(atendimentosDia, function(o) {
					return moment(o.date).format("HH:mm") === horaCorreta + ':00'
				})

				if (atendimentoHoraIndex >= 0) {
					horariosDia[cont] = { atendimento: atendimentosDia[atendimentoHoraIndex] }
					_.remove(atendimentosDia, function(o) {
						return moment(o.date).format("HH:mm") === horaCorreta + ':00'
					})
				}

				horariosDia[cont].hora = { horaCorreta }
				horasJaMarcada.push(horaCorreta + ':00')
				cont++
			}
		}

		this.hourCanUseToSingleHour = this.horariosDoDia

		horasJaMarcada.forEach(hourToRemove => {
			this.hourCanUseToSingleHour = _.filter(this.hourCanUseToSingleHour, function(n) {
				const time = n.length === 4 ? '0' + n : n
				return time !== hourToRemove
			})
		})

		const singleHoursFormatted = this.getSingleHoursToThisDay(clickedDateFormatted)

		if (!_.isEmpty(singleHoursFormatted)) {
			singleHoursFormatted.forEach(newSingleHour => {
				const atendimentoHoraIndex = _.findIndex(atendimentosDia, function(o) {
					return moment(o.date).format("HH:mm") === newSingleHour.hora.horaCorreta + ':00'
				})
				if (atendimentoHoraIndex >= 0) {
					newSingleHour.atendimento = atendimentosDia[atendimentoHoraIndex]
				}
				horariosDia.push(newSingleHour)
			})
	
			this.singleHours.forEach(singleHourToRemove => {
				this.hourCanUseToSingleHour = _.filter(this.hourCanUseToSingleHour, function(n) {
					const time = n.length === 4 ? '0' + n : n
					return time !== singleHourToRemove.hour + ':00'
				})
			})
		}

		horariosDia = _.sortBy(horariosDia, ['hora.horaCorreta'])

		this.infoDay['horariosDia'] = null

		if (!_.isEmpty(horariosDia)) {
			this.infoDay['horariosDia'] = horariosDia
		}
	}

	getSingleHoursToThisDay(day) {
		const singleHourToDate = _.filter(this.singleHours, (o) => { return o.day === day })
		if (!_.isEmpty(singleHourToDate)) {
			let result = []
			singleHourToDate.forEach((element) => {
				result.push({
					atendimento: '',
					hora: {
						horaCorreta: element.hour
					},
					info: 'Horiário avulso',
					single: true
				})
			})
			return result
		}
		return null
	}

	setHorario(horario) {
		horario.selected = !horario.selected;
	}

	salvarHorarios() {
		this.loadingHorarios = true
		this.agendaService
			.newAgenda(this.retirarOffsetAgendaCustomizada(this.agendaCustomizada))
			.subscribe(
				(res) => {
					this.toastr.success('Novo horário salvo', 'Sucesso')
					setTimeout(() => {
						window.location.reload()
					}, 1000)
					return
				},
				(err) => {
					this.toastr.error('Não foi possível salvar a agenda', 'Erro')
					console.log(err)
					return
				}
			);
	}

	retirarOffsetAgendaCustomizada(agenda) {
		let agendaCorreta = [];
		for (let horario = 0; horario < 24; horario++) {
			agendaCorreta.push([]);
			for (let i = 0; i < 7; i++) {
				agendaCorreta[horario].push({
					hora: (horario < 10 ? "0" + horario : horario) + ":00",
					selected: false,
				});
			}
		}

		for (let hora = 0; hora < agenda.length; hora++) {
			for (let dia = 0; dia < agenda[hora].length; dia++) {
				if (agenda[hora][dia].selected) {
					let horaCorreta = hora - this.offset
					let diaCorreto = dia;
					if (horaCorreta >= 24) {
						horaCorreta = horaCorreta - 24;
						diaCorreto++;
						if (diaCorreto > 6) {
							diaCorreto = 0;
						}
					} else if (horaCorreta < 0) {
						horaCorreta = horaCorreta + 24;
						diaCorreto--;
						if (diaCorreto < 0) {
							diaCorreto = 6;
						}
					}

					this.agendaUTC[hora][dia].selected = false;
					agendaCorreta[horaCorreta][diaCorreto].selected = true;
				}
			}
		}

		return agendaCorreta;
	}

	getAtendimentos() {
		this.atendimentoService
			.getAtendimentos(0, 500, this.status)
			.subscribe(
				(res) => {
					for (let atendimento of res["atendimentos"]) {
						for (let usuario of res["usuarios"]) {
							if (parseInt(atendimento.userId) === parseInt(usuario.id)) {
								atendimento.usuario = usuario;
							}
						}
					}

					this.atendimentos = res["atendimentos"];

					this.setEventos();
				},
				(err) => {
					console.log(err);
				}
			);
	}

	setEventos() {
		for (let atendimento of this.atendimentos) {
			let title = ''
			if (atendimento.status === 'Bloqueado') {
				title = 'Bloqueado'
			} else {
				title = atendimento.usuario.name.split(' ')[0] + atendimento.usuario.name.split(' ')[1]
			}
			this.events = this.events.concat({
				id: atendimento.id,
				title,
				start: moment(atendimento.date).format('YYYY-MM-DDTHH:mm:ss'),
				color: this.getColor(atendimento.status)
			})
		}
		
		this.singleHours.forEach(element => {
			const fixHour = parseInt(element.hour) - this.offset
			const formattedDate = moment(element.day).hour(fixHour).minute(0).second(0).format('YYYY-MM-DDTHH:mm:ss')
			// console.log('-------------- COMEÇA AQUI ----------------')
			// console.log(element)
			// console.log(formattedDate)
			// console.log('-------------- TERMINA AQUI ----------------')
			// const findAlreadyEvent = _.find(this.events, (o) => {
			// 	return o.start === formattedDate
			// })

			// if (findAlreadyEvent) {
			// 	console.log('-------------- COMEÇA AQUI ----------------')
			// 	console.log('achou')
			// 	console.log('-------------- TERMINA AQUI ----------------')
			// } else {
			// 	console.log('-------------- COMEÇA AQUI ----------------')
			// 	console.log('nao achou')
			// 	console.log('-------------- TERMINA AQUI ----------------')
			// }
		});
	}

	clearEvents() {
		this.events = []
	}

	getColor(status) {
		switch (status) {
			case 'Aguardando pagamento':
				return '#ffff008c';
				break;
			case 'Agendado':
					return '#00800080';
					break;
			case 'Bloqueado':
						return '#ff000070';
						break;
			case 'transparente':
					return 'transparent'
					break;
			default:
				return '#3788d873';
				break;
		}
	}

	dayRender (ev) {
		if (this.diasComHorario.includes(moment(ev.date).day()) && moment().isSameOrBefore(moment(ev.date))) {
			ev.el.classList.add('day_atendimento')
		}
		if (this.diasComHorario.includes(moment(ev.date).day()) && !moment().isSameOrBefore(moment(ev.date))) {
			ev.el.classList.add('day_atendimento_past')
		}
  }

	async blockFreeHour (infoDayEvent, hour) {
		const hourAndDaytoBlock = moment(infoDayEvent).hour(hour).toDate()
		this.atendimentoService.blockFreeHour({ date: hourAndDaytoBlock })
			.subscribe(
				async (res) => {
					this.clearEvents()
					await this.getAtendimentos()
					const changeEv = _.findIndex(this.infoDay['horariosDia'], (o) => o.hora.horaCorreta === hour)
					this.infoDay['horariosDia'][changeEv].atendimento = { status: 'Bloqueado' }
					this.toastr.success('Horário bloqueado', 'Sucesso')
					return
				},
				(err) => {
					if (err.status === 403) {
						this.toastr.error('Não pode bloquear esse horário!', 'Erro')
						return
					}
					console.log(err)
					this.toastr.error('Erro ao bloquear horário', 'Erro')
				}
			);
	}

	async unblockFreeHour (infoDayEvent, hour) {
		const hourAndDaytoBlock = moment(infoDayEvent).hour(hour).toDate()
		this.atendimentoService.unblockFreeHour({ date: hourAndDaytoBlock })
			.subscribe(
				async (res) => {
					this.clearEvents()
					await this.getAtendimentos()
					const changeEv = _.findIndex(this.infoDay['horariosDia'], (o) => o.hora.horaCorreta === hour)
					this.infoDay['horariosDia'][changeEv].atendimento = ''
					this.toastr.success('Horário desbloqueado', 'Sucesso')
					return
				},
				(err) => {
					if (err.status === 403) {
						this.toastr.error('Não pode desbloquear esse horário!', 'Erro')
						return
					}
					console.log(err)
					this.toastr.error('Erro ao desbloquear horário', 'Erro')
				}
			);
	}

	async removeFreeHour (infoDayEvent, hourToRemove) {
		const { day, hour, dayNumber } = this.removeOffsetToDayAndHour(infoDayEvent, hourToRemove)
		this.atendimentoService.removeFreeHour({
			dia: day,
			dayNumber,
			hour 
		})
		.subscribe(
			async (res) => {
				this.toastr.success('Horário removido', 'Sucesso')
				setTimeout(() => {
					window.location.reload()
				}, 1000)
				return
			},
			(err) => {
				if (err.status === 403) {
					this.toastr.error('Não pode desbloquear esse horário!', 'Erro')
					return
				}
				console.log(err)
				this.toastr.error('Erro ao desbloquear horário', 'Erro')
			}
		);
	}

	async blockAllDay () {
		const dayToBlock = []
		for (let index = 0; index < this.infoDay['horariosDia'].length; index++) {
			const element = this.infoDay['horariosDia'][index]
			dayToBlock.push(moment(this.infoDay['date']).hour(element.hora.horaCorreta).toDate())
		}
		this.atendimentoService
			.blockAllDay({ date: dayToBlock })
			.subscribe(
				async (res) => {
					this.clearEvents()
					await this.getAtendimentos()
					for (let index = 0; index < this.infoDay['horariosDia'].length; index++) {
						this.infoDay['horariosDia'][index].atendimento = { status: 'Bloqueado' }
					}
					this.toastr.success('Dia bloqueado com sucesso', 'Sucesso')
					return
				},
				(err) => {
					if (err.status === 403) {
						this.toastr.error('Não pode bloquear esse dia!', 'Erro')
						return
					}
					console.log(err.status);
					this.toastr.error('Erro ao bloquear horário', 'Erro')
				}
			);
	}

	addNewHour (infoDay) {
		if (!this.newHour) {
			this.toastr.error('Precisa selecionar um horário!', 'Erro')
			return
		}
		const fixDayAndHour = moment(infoDay).hour(parseInt(this.newHour) - this.offset).minute(0).second(0)

		this.atendimentoService.addNewHour({
			day: fixDayAndHour.format('YYYY-MM-DD'),
			hour: fixDayAndHour.format('HH:mm')
		})
		.subscribe(
			async (res) => {
				this.toastr.success('Novo horário avulso adicionado', 'Sucesso')
				setTimeout(() => {
					window.location.reload()
				}, 1000)
				return
			},
			(err) => {
				if (err.status === 403) {
					this.toastr.error('Não pode bloquear esse horário!', 'Erro')
					return
				}
				console.log(err)
				this.toastr.error('Erro ao bloquear horário', 'Erro')
			}
		);
	}

	removeOffsetToDayAndHour(day, hour) {
		let hourWithoutOffset = parseInt(hour) - this.offset;
		let fixDay = moment(day)

		if (hourWithoutOffset >= 24) {
			hourWithoutOffset = hourWithoutOffset - 24;
			fixDay.add(1, 'day')
		} else if (hourWithoutOffset < 0) {
			hourWithoutOffset = hourWithoutOffset + 24;
			fixDay.subtract(1, 'day')
		}
		return {
			day: fixDay.format('YYYY-MM-DD'),
			hour: hourWithoutOffset,
			dayNumber: fixDay.day()
		}
	}

	addOffsetToDayAndHour(day, hour) {
		let hourWithOffset = parseInt(hour) + this.offset;
		let fixDay = moment(day)

		if (hourWithOffset >= 24) {
			hourWithOffset = hourWithOffset - 24;
			fixDay.add(1, 'day')
		} else if (hourWithOffset < 0) {
			hourWithOffset = hourWithOffset + 24;
			fixDay.subtract(1, 'day')
		}
		return {
			day: fixDay.format('YYYY-MM-DD'),
			hour: hourWithOffset,
			dayNumber: fixDay.day()
		}
	}
}
